var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCambodia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0127C0 18.7846 0.705188 21.3917 1.94544 23.6649L16 25.0562L30.0546 23.6649C31.2948 21.3917 32 18.7846 32 16.0127C32 13.2409 31.2948 10.6337 30.0546 8.36055L16 6.96924L1.94544 8.36055C0.705188 10.6337 0 13.2409 0 16.0127H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94543 8.36051H30.0545C27.3409 3.38701 22.0647 0.0126953 16 0.0126953C9.93531 0.0126953 4.65912 3.38701 1.94543 8.36051V8.36051Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0126C22.0647 32.0126 27.3409 28.6383 30.0546 23.6648H1.94543C4.65912 28.6383 9.93531 32.0126 16 32.0126Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 19.1431V17.0561H20.1739V14.2735L18.7826 12.8822L17.3913 14.2735V11.4909L16 10.0995L14.6087 11.4909V14.2735L13.2173 12.8822L11.826 14.2735V17.0561H10.4348V19.1431H9.04346V21.23H22.9565V19.1431H21.5652Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0126953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCambodia);
export default __webpack_public_path__ + "static/media/cambodia.0444ae69.svg";
export { ForwardRef as ReactComponent };